import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-story-banner")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-story-banner")),
  head: () => ({
    meta: [
      { title: "بلوك ٨ — إدارة" },
      { name: "description", content: "تحكّم ببلوك ٨ في الصفحة الرئيسيّة." },
    ],
  }),
});
